import Profile from './container';

export default Profile;



// WEBPACK FOOTER //
// ./src/routes/Profile/index.js